import { Navigate, Route, Routes } from "react-router-dom";
import { Admin } from "./Admin";
import { LoadingScreen } from "./components/LoadingScreen";
import { useAdminSession } from "./lib/session";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Agents } from "./pages/Agents";
import { SuperDealers } from "./pages/SuperDealers";
import { KYC } from "./pages/KYC";
import { Orders } from "./pages/Orders";
import { Wallets } from "./pages/Wallets";
import { Funding } from "./pages/Funding";
import { DealerTopups } from "./pages/DealerTopups";
import { Approvals } from "./pages/Approvals";
import { Refunds } from "./pages/Refunds";
import { Recon } from "./pages/Recon";
import { Finance } from "./pages/Finance";
import { Reports } from "./pages/Reports";
import { Settings } from "./pages/Settings";
import { Support } from "./pages/Support";
import { Help } from "./pages/Help";

function Protected({ children }: { children: React.ReactNode }) {
  const { admin, loading } = useAdminSession();
  if (loading) return <LoadingScreen />;
  if (!admin) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function NotFound() {
  return (
    <div className="ev-empty" style={{ minHeight: 360 }}>
      <strong className="ev-h3">Page not found</strong>
      <p className="ev-caption">The page you were looking for has moved or never existed.</p>
      <a className="ev-btn ev-btn-sm ev-btn-secondary" href="/">Back to dashboard</a>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Admin />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="agents" element={<Agents />} />
        <Route path="superdealers" element={<SuperDealers />} />
        <Route path="kyc" element={<KYC />} />
        <Route path="orders" element={<Orders />} />
        <Route path="wallets" element={<Wallets />} />
        <Route path="funding" element={<Funding />} />
        <Route path="dealer-topups" element={<DealerTopups />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="refunds" element={<Refunds />} />
        <Route path="recon" element={<Recon />} />
        <Route path="finance" element={<Finance />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="support" element={<Support />} />
        <Route path="help" element={<Help />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
